import React from "react";

const DeleteXBtn = props => (
	<svg
		width={10}
		height={10}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m1 9 8-8M1 1l8 8"
			stroke="#A7A5A6"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default DeleteXBtn;